import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-home_sm_circle",
  "use": "icon-home_sm_circle-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 30 30\" id=\"icon-home_sm_circle\">\n    <circle r=\"14.76\" fill=\"#F39801\" stroke=\"#F39801\" stroke-width=\".48\" transform=\"matrix(-1 0 0 1 15 15)\" />\n    <path fill=\"#E1F5F3\" stroke=\"#F39801\" stroke-width=\".571\" d=\"M25.524 15.046c0 5.804-4.705 10.51-10.509 10.51S4.506 20.85 4.506 15.045c0-5.803 4.705-10.508 10.51-10.508 5.803 0 10.508 4.705 10.508 10.508z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol